
// ============================================
// PRODUCTOS DESTACADOS - CONFIGURACIÓN
// ============================================
// Aquí puedes elegir qué 6 productos mostrar en la sección de destacados.
// Solo cambia los productos que quieras mostrar.
// Máximo 6 productos.
// ============================================

import { energeticasProducts } from './energeticas';
import { abarrotesProducts } from './abarrotes';
import { aguaProducts } from './agua';
import { gaseosasProducts } from './gaseosas';
import { papelHigienicoProducts } from './papel-higienico';
import { isotonicasProducts } from './isotonicas';

// ============================================
// SELECCIÓN DE PRODUCTOS DESTACADOS
// ============================================
// Modifica esta lista para elegir qué productos mostrar.
// Usa el formato: { ...producto, category: 'nombre-categoria' }
// ============================================

export const featuredProductsConfig = [
  // 1. Energética Score Gorilla
  { ...energeticasProducts[0], category: 'energeticas' },
  
  // 2. Azúcar Iansa
  { ...abarrotesProducts[3], category: 'abarrotes' },
  
  // 3. Pepsi lata
  { ...gaseosasProducts[3], category: 'gaseosas' },
  
  // 4. Cachantún sin gas
  { ...aguaProducts[5], category: 'agua' },
  
  // 5. Papel Swan
  { ...papelHigienicoProducts[1], category: 'papel-higienico' },
  
  // 6. Gatorade Cold Blue
  { ...isotonicasProducts[0], category: 'isotonicas' },
];

// ============================================
// REFERENCIA DE PRODUCTOS DISPONIBLES
// ============================================
// 
// ENERGÉTICAS (energeticasProducts):
// [0] Score Gorilla 473 ml
// [1] Score Original 473 ml
// [2] Score Gorilla Zero 473 ml
// [3] Score Fruit Punch 473 ml
// [4] Score Bubble Gum 473 ml
// [5] Score Radical White 473 ml
// [6] Score Mojito 473 ml
// [7] Score Mango 500 ml
// [8] Red Bull 250 ml
// [9] Monster 473 ml
//
// ABARROTES (abarrotesProducts):
// [0] Azúcar La Teresita 1 kg
// [1] Azúcar Mi Sol 1 kg
// [2] Azúcar Amelia 1 kg
// [3] Azúcar Iansa 1 kg
// [4] Azúcar Iansa 1.7 kg
// [5] Arroz Miraflores 1 kg
// [6] Arroz Tucapel 900 g
// [7] Arroz Bonanza 1 kg
// [8] Arroz Teodoro 1 kg
// [9] Arroz Mi Sol 1 kg
// [10] Aceite de Oliva VDR 250 ml
// [11] Aceite Maravilla Miraflores 900 ml
// [12] Aceite Vegetal Mi Sol 900 ml
// [13] Aceite Vegetal De Reyes 900 ml
// [14] Sal Económica 1 kg
// [15] Sal Lobos 1 kg
//
// AGUA (aguaProducts):
// [0] Cachantún con gas 600 ml
// [1] Benedictino con gas 500 ml
// [2] Cachantún con gas 1.6 L
// [3] Agua Score con gas 500 ml
// [4] Agua Vital con gas 600 ml
// [5] Cachantún sin gas 600 ml
// [6] Benedictino sin gas 500 ml
// [7] Cachantún sin gas 1.6 L
// [8] Agua Vital sin gas 600 ml
// [9] Agua Score sin gas 500 ml
//
// GASEOSAS (gaseosasProducts):
// [0] Canada Dry lata 350 ml
// [1] Bilz lata 350 ml
// [2] Pap lata 350 ml
// [3] Pepsi lata 350 ml
// [4] Pepsi Zero lata 350 ml
// [5] Kem Piña lata 350 ml
// [6] Limón Soda lata 350 ml
// [7] Coca-Cola lata 350 ml
// [8] Coca-Cola Zero lata 350 ml
// [9] Sprite lata 350 ml
//
// PAPEL HIGIÉNICO (papelHigienicoProducts):
// [0] Noble 22 m
// [1] Swan 22 m
// [2] Elite 50 m hoja doble
// [3] Abolengo 100 m
// [4] Nova ultra 70 m
//
// ISOTÓNICAS (isotonicasProducts):
// [0] Gatorade Cold Blue 1 L
// [1] Gatorade Frutas Tropicales 1 L
// [2] Gatorade Cold Blue 750 ml
// [3] Gatorade Frutas Tropicales 750 ml
// [4] Powerade Frozen Blast 1.1 L
// [5] Powerade Rojo 1.1 L
// [6] Powerade Naranja 1.1 L
// [7] Powerade Frozen Blast 850 ml
// [8] Powerade Rojo 850 ml
// [9] Powerade Naranja 850 ml
// ============================================
